//===================================================
// 1.Load,Init,Settings
//===================================================
import React from "react";

// Material-ui
import {
  Button,
  TextField,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Link,
  Container,
  CircularProgress,
} from "@mui/material";

// custom components
import { CustomPhoneField } from "../../atoms";

// css *required
import { useStyles } from "./index.css";

//===================================================
// 2.Main Component
//===================================================
const InformationForm = (props) => {
  // 2-1. useStyles *require
  const classes = useStyles();

  // 2-2. Store

  // showMain
  return showMain({
    ...props,
    classes,
  });
};

//===================================================
// 3.Export
//===================================================
export default InformationForm;

//===================================================
// 4.propTypes and defaultProps
//===================================================

//4-1. propTypes
InformationForm.propTypes = {};

//4-2. defaultProps
InformationForm.defaultProps = {};

//===================================================
// 5.Functions *require showMain()
//===================================================
/**
 * Show main
 * @param {*} props
 */
const showMain = (props) => {
  const {
    classes,
    isLoading,
    hasError,
    setTermsAndPolicy,
    userInfo,
    disabled,
  } = props;
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleOnSubmit(props);
      }}
    >
      <Grid
        container
        rowSpacing={2}
        sx={{ p: 0 }}
        columnSpacing={{ xs: 1, sm: 2, md: 2 }}
      >
        <Grid item xs={12}>
          <TextField
            error={Boolean(hasError.email)}
            type="email"
            label="Email"
            autoComplete="email"
            name="email"
            value={userInfo.email || ""}
            onChange={(e) => handleInputChange(e.target, props)}
            fullWidth
            helperText={hasError.email}
            inputProps={{ readOnly: disabled }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={Boolean(hasError.firstName)}
            label="First name"
            autoComplete="given-name"
            name="firstName"
            value={userInfo.firstName || ""}
            onChange={(e) => handleInputChange(e.target, props)}
            fullWidth
            helperText={hasError.firstName}
            inputProps={{ readOnly: disabled }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={Boolean(hasError.lastName)}
            label="Last name"
            autoComplete="family-name"
            name="lastName"
            value={userInfo.lastName || ""}
            onChange={(e) => handleInputChange(e.target, props)}
            fullWidth
            helperText={hasError.lastName}
            inputProps={{ readOnly: disabled }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomPhoneField
            setPhoneNumber={(val) =>
              handleInputChange({ name: "phone", value: val }, props)
            }
            hasError={hasError.phoneNumber}
            loginUserPhone={userInfo.phone}
            selectedCountry={props.selectedCountry}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Notes for the team (optional)"
            name="note"
            value={userInfo.note || ""}
            onChange={(e) => handleInputChange(e.target, props)}
            fullWidth
            multiline
            minRows={3}
            placeholder="Access instructions, parking, pets, or special requests"
          />
        </Grid>
      </Grid>

      <Container className={classes.container} maxWidth={false} sx={{ mt: 2, px: 0 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                onChange={(e) => setTermsAndPolicy(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2" component="span" color="text.secondary">
                I have read and accept the{" "}
                <Link
                  href="https://cleaningly.com.au/terms-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms &amp; Conditions
                </Link>{" "}
                and{" "}
                <Link
                  href="https://cleaningly.com.au/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .
              </Typography>
            }
            sx={{ alignItems: "flex-start", ml: 0 }}
          />
        </FormGroup>
        {hasError.agree ? (
          <Typography variant="caption" color="error" display="block" sx={{ mt: 0.5 }}>
            {hasError.agree}
          </Typography>
        ) : null}

        {hasError.message ? (
          <Typography variant="caption" color="error" display="block" sx={{ mt: 1 }}>
            {hasError.message}
          </Typography>
        ) : null}
      </Container>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        size="large"
        disableElevation
        fullWidth
        disabled={isLoading}
        sx={{ mt: 3 }}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Complete booking"
        )}
      </Button>
    </form>
  );
};

//===================================================
// 6.Actions
//===================================================

/**
 * submit booking
 * @param {*} props
 */
const handleOnSubmit = (props) => {
  const { handleSubmitBooking } = props;
  handleSubmitBooking && handleSubmitBooking();
};

const handleInputChange = (input, props) => {
  const { setInformation } = props;
  const name = input.name;
  const value = input.value;
  setInformation({
    [name]: value,
  });
};
